import React from 'react';

export function Success() {
    return(
        <>
            <div className='success-container'>
                <header className='header'>
                    <img src={require('./../imgs/loyaltea-logo.png')} alt='Loyaltea logo' className='header-logo' />
                    <h1>Loyaltea</h1>
                </header>
                <section className='success'>
                    <h2>Congratulations, you've successfully joined the waitlist!</h2>
                    <h3>If you’d like, share the link below with other business owners to create your private Unified Loyalty Network as soon as we launch.</h3>
                    <a href='https://waitlist.myloyaltea.com/' target="_blank" rel="noopener noreferrer">https://waitlist.myloyaltea.com/</a>
                    <p>We truly appreciate you taking the time to share your insights. We're pleased to confirm that you are now on our waitlist! You’ll be among the first to receive updates and news about the launch of our Unified Loyalty Network. We're excited to have you on board and look forward to embarking on this journey together!</p>
                    <img src={require('./../imgs/success.png')} alt='Celebration' className='success-image' />
                </section>
            </div>
        </>
    )
}